import { Agpm } from '@/types';
import { Component, inject, effect } from '@angular/core';
import { AgpmService } from '../agpm.service';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { MessageService } from 'primeng/api';
import { ActivatedRoute, Router } from '@angular/router';
import { DataTableRowActions, DynamicDataTable } from '@/components/data-table-builder/data-table.types';
import { getAgpmHistoryDataTableStructure } from './utils/agpm-history-data-table-object';
import { PageHeaderComponent } from '../../../components/shared/page-header/page-header.component';
import { DataTableBuilderComponent } from '../../../components/data-table-builder/data-table-builder.component';
import { createServerQuery } from '../../../components/data-table-builder/server-query';
import { AgpmRepository } from '@/store/agpm-state/agpm-state.repository';

@Component({
  selector: 'sm-agpm-history',
  imports: [PageHeaderComponent, DataTableBuilderComponent, TranslateModule],
  templateUrl: './history.component.html',
  styleUrl: './history.component.scss',
})
export class AgpmHistoryComponent {
  agpmRepository = inject(AgpmRepository);
  agpmService = inject(AgpmService);
  translate = inject(TranslateService);
  messageService = inject(MessageService);
  activatedRoute = inject(ActivatedRoute);
  router = inject(Router);

  breadcrumb = [
    {
      label: 'agpm.breadcrumb.agpm',
      routerLink: ['/agpm-current-notice'],
    },
    {
      label: 'agpm.breadcrumb.agpmHistory',
      routerLink: ['agpm-history'],
    },
  ];

  data: Agpm[] = [];
  loading = false;

  rowActions: DataTableRowActions = {
    defaultActions: {
      inspect: {
        label: 'agpm.actions.inspect',
      },
    },
    inspectAction: (row: Agpm) => {
      this.router.navigate([`agpm-inspect-notice/${row.id}/${row.version}`]);
    },
  };

  serverQuery = createServerQuery({ initialPageSize: 10, initialSortBy: 'updatedAt', initialSortOrder: 'desc' });

  dataTableObject: DynamicDataTable = getAgpmHistoryDataTableStructure({
    store: this.agpmRepository,
    rowActions: this.rowActions,
    serverQuery: this.serverQuery,
  });

  totalRecords = 0;

  constructor() {
    effect(() => {
      const page = this.serverQuery.page();
      const size = this.serverQuery.pageSize();
      const sortBy = this.serverQuery.sortBy();
      const sortOrder = this.serverQuery.sortOrder();
      const search = this.serverQuery.search();
      const sort = sortBy ? `${sortBy},${sortOrder}` : 'updatedAt,desc';
      this.loadData(page, size, sort, search);
    });
  }

  loadData(page = 0, size = 10, sort = 'updatedAt,desc', search?: string) {
    this.loading = true;
    this.agpmService.getAgpms({ page, size, sort, search }).subscribe({
      next: data => {
        this.data = data.content;
        this.totalRecords = data.totalElements;
        this.loading = false;
      },
      error: err => {
        this.loading = false;
        this.messageService.add({
          severity: 'error',
          summary: 'Erreur',
          detail: err.error.message || this.translate.instant('agpm.message.error.loading'),
        });
      },
    });
  }
}
